module.exports = __webpack_public_path__ + "static/media/spinner.a1a1a4b0.svg";